<template>
	<div class="score-box">
		<div class="content-box">
			<div class="header-score-box"> </div>
			<div class="body-score-box">
				<div class="count-questions">
					<div class="details table-responsive">
						<table class="table" key="count-questions-table">
							<thead class="">
								<tr>
									<th class="answered-questions">Passed</th>
									<th class="remain-questions">Remain</th>
									<th class="total-questions">Total</th>
								</tr>
							</thead>
							<tbody>
								<tr>
									<td class="answered-questions">
										<transition name="slideUp" appear mode="out-in">
											<span :key="hash(answeredQuestions+'answeredQuestions')">
												{{answeredQuestions}}
											</span>
										</transition>
									</td>
									<td class="remain-questions">
										<transition name="slideUp" appear mode="out-in">
											<span :key="hash(answeredQuestions+'answeredQuestions')">
												{{ (totalQuestions - answeredQuestions==0?'latest':totalQuestions - answeredQuestions) }}
											</span>
										</transition>
									</td>
									<td class="total-questions" :key="totalQuestions">{{totalQuestions}}</td>
								</tr>
							</tbody>
						</table>
					</div>
				</div>
				<div class="corrected">
					<div class="details table-responsive">
							<table class="table table-bordered">
								<thead>
									<tr>
										<th class="truths-answers">Succeed</th>
										<th class="fails-answers">Failed</th>
									</tr>
								</thead>
								<tbody>
									<tr>
										<td class="truths-answers">
											<transition name="slideUp" appear mode="out-in">
												<span :key="hash(nbreTruthsQuestions+'nbreTruthsQuestions')">{{nbreTruthsQuestions}}</span>
											</transition>
										</td>
										<td class="fails-answers">
											<transition name="slideUp" appear mode="out-in">
												<span :key="hash(answeredQuestions+'answeredQuestions')">
													{{Math.max(answeredQuestions - nbreTruthsQuestions,0)}}
												</span>
											</transition>
										</td>
									</tr>
								</tbody>
							</table>
						
					</div>
				</div>
			</div>
			<div class="score-report">
				<div class="score-block">
					<span class="lbl-score">Score : </span>
					<transition name="slideDown" appear mode="out-in">
						<span class="score-value" :key="hash(score+'score')">{{Math.round(score)}}</span>
					</transition>
				</div>
				<transition name="zoomUp" appear>
					<div class="apreciation-score" :key="hash(apreciationScore+'apreciationScore')">{{apreciationScore}}</div>
				</transition>
			</div>
		</div>
	</div>
</template>

<script type="text/javascript">
	let apreciations=["Bad","Insufiscient","Mediocre","Passable","Good"], n=parseInt(100/apreciations.length);
	import BaseExerciseMixin from '../js/BaseExerciseMixin';
	export default {
		mixins:[BaseExerciseMixin],
		name:'score-box',
		props:{
			totalQuestions:{type:Number, required:true, default:1},
			nbreTruthsQuestions:{type:Number, required:true, default:0},
			answeredQuestions:{type:Number, required:true, default:0},
			score:{type:Number, required:true, default:0},
		},
		data(){
			return {
				apreciationScore:'',
			}
		},
		created(){},
		mounted(){},
		methods:{},
		computed:{

		},
		watch:{
			nbreTruthsQuestions(old, new_){
				this.apreciationScore = apreciations[parseInt(this.score/n)];
				this.$emit('apreciation', this.apreciationScore);
			}
		},
	};
</script>